import { useEffect } from 'react';

interface UseThemeOptions {
  visualRefresh?: boolean;
}

export const useTheme = (options: UseThemeOptions = { visualRefresh: true }) => {
  useEffect(() => {
    if (options.visualRefresh) {
      document.body.className = 'awsui-visual-refresh';
    } else {
      document.body.className = '';
    }

    return () => {
      document.body.className = '';
    };
  }, [options.visualRefresh]);
};